import { Box, Text } from '@chakra-ui/react'
import { RequestPreviewPopover } from '../RequestPreviewPopover'

type Props = {
  subject: string
  headerText: string // "Carol Lam submitted a new ticket"
  description: string
}

export function DescriptionHoverCell({
  subject,
  headerText,
  description,
}: Props) {
  return (
    <RequestPreviewPopover
      title={headerText}
      description={description}
      trigger={
        <Box maxW="260px">
          <Text
            noOfLines={1}
            color="blue.600"
            fontWeight="medium"
            cursor="default"
            _hover={{ textDecoration: 'underline' }}
          >
            {subject}
          </Text>
        </Box>
      }
    />
  )
}
